import { syncContactsWithCache } from "../../state/actions/contacts";
import store from "../../state/configureStore";
import ContactsServiceClient from "./ContactsServiceClient";
import {
	getDataFromLFStorage,
	LFStorageKeys,
	saveDataInLFStorage,
} from "../storage/LFStorage";
import webSocketApiService from "../socket/wsApiServices";

export function search(searchKey, selectedDomain) {
	return webSocketApiService.Find({
		queryString: searchKey,
		selectedDomain: selectedDomain,
	}).then((data) => {
		const { content: contacts } = data;
		return contacts || [];
	});
}

export function addContacts(data, type, selectedDomain) {
	if (type === "search") {
		return webSocketApiService.Add(
			{
				userIds: data,
				selectedDomain: selectedDomain,
			},
			true
		).then((data) => {
			const { error } = data;
			if (error && error !== 0) {
				throw new Error();
			}
		});
	}

	if (type === "form") {
		return webSocketApiService.Add({
			localContacts: data,
			selectedDomain:selectedDomain
		}).then((data) => {
			const { error } = data;
			if (error && error !== 0) {
				throw new Error();
			}
		});
	}
}

export async function updateLocalContact(data, selectedDomain) {
	return webSocketApiService.Update({
		localContacts: data,
		selectedDomain: selectedDomain
	}).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}

export async function inviteByEmail(emails, selectedDomain) {
	return webSocketApiService.Invite({
		emailIds: emails,
		selectedDomain: selectedDomain,
	}).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}

export async function removeContacts(users, type, selectedDomain) {
	if (type === "local") {
		return webSocketApiService.Remove({ localContacts: [users], selectedDomain: selectedDomain }).then(
			async (data) => {
					const { error } = data;
					if (error && error !== 0) {
						throw new Error();
					}
					let contactsList =
						(await getDataFromLFStorage(
							`${LFStorageKeys.CONTACTS}_${selectedDomain}`
						)) || [];

					if (contactsList) {
						contactsList.localContacts = contactsList?.localContacts?.filter(
							(contact) => users.userId !== contact.userId
						);
						saveDataInLFStorage(
							`${LFStorageKeys.CONTACTS}_${selectedDomain}`,
							contactsList
						);
						store.dispatch(syncContactsWithCache(contactsList));
					}
			}
		);
	}
	return webSocketApiService.Remove({ userIds: users, selectedDomain: selectedDomain }).then(async (data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
		let contactsList =
			(await getDataFromLFStorage(
				`${LFStorageKeys.CONTACTS}_${selectedDomain}`
			)) || [];

		if (contactsList) {
			contactsList.contacts = contactsList?.contacts?.filter(
				(contact) => !users.includes(contact.userId)
			);
			saveDataInLFStorage(
				`${LFStorageKeys.CONTACTS}_${selectedDomain}`,
				contactsList
			);
			store.dispatch(syncContactsWithCache(contactsList));
		}
	});
}

export async function acceptContacts(users, selectedDomain) {
	return webSocketApiService.Accept({ userIds: users, selectedDomain: selectedDomain }).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}

export async function ignoreContacts(users, selectedDomain) {
	return webSocketApiService.Ignore({ userIds: users, selectedDomain: selectedDomain }).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}
